import React from 'react'
import { Segmented, Space } from 'antd'
import { usePaymentMethod } from '../hooks'

import styles from './PricingToggle.module.css'

export const PaymentMethodToggle: React.FC = () => {
  const { paymentMethod, setPaymentMethod } = usePaymentMethod()
  const { billingPeriod } = usePaymentMethod()
  
  return (
    billingPeriod === 'monthly' 
    ? null 
    : <div className={styles.container}>
      <Space direction='vertical'>
        <Segmented
          options={[
            { label: 'Pay by Invoice', value: 'invoice' },
            { label: 'Pay with Card', value: 'card' },
          ]}
          value={paymentMethod}
          style={{
            borderRadius: 8
          }}
          className={styles.segmented}
          onChange={(val) => setPaymentMethod(val as 'invoice' | 'card')}
          block
        />
      </Space>
    </div>
  )
}
